export type PlayerSearchOrigin = "accounts" | "playfab";

export function playerSearchOrigin(value: unknown): PlayerSearchOrigin {
  if (value && typeof value === "object" && "origin" in value && value.origin === "playfab") {
    return "playfab";
  }
  return "accounts";
}

export function playerSearchPath(origin: PlayerSearchOrigin): string {
  return origin === "playfab" ? "/players" : "/accounts";
}
